import React, { useState, useEffect } from "react";
import { Accordion, List, Checkbox, Button, Modal } from "semantic-ui-react";

import SettingsService from "../services/settingsService";

export default function SettingsComponent() {
  const [settings, setSettings] = useState(SettingsService.getSettings());
  useEffect(() => {
    SettingsService.sendSettings(settings);
  }, [settings]);

  const toggleSetting = (setting) => {
    setSettings({
      ...settings,
      [setting]: !settings[setting],
    });
  };

  const restoreDefaults = () => {
    const defaults = SettingsService.defaultSettings();
    delete defaults["currentVideoId"];
    setSettings(defaults);
  };

  const panels = [
    {
      key: "settings",
      title: {
        content: "Settings",
      },
      content: {
        content: (
          <div>
            <i>Settings are stored using browser cookies</i>
            <List>
              <List.Item onClick={() => toggleSetting("filterArtifacts")}>
                <Checkbox
                  label="Filter out translation artifacts"
                  checked={settings["filterArtifacts"]}
                />
              </List.Item>
              <List.Item onClick={() => toggleSetting("background")}>
                <Checkbox
                  label="Add dark background to translation text"
                  checked={settings["background"]}
                />
              </List.Item>
              <List.Item onClick={() => toggleSetting("above")}>
                <Checkbox
                  label="Place translation above original text"
                  checked={settings["above"]}
                />
              </List.Item>
              <List.Item onClick={() => toggleSetting("skipIntro")}>
                <Checkbox
                  label="Skip intros (applies on next video load)"
                  checked={settings["skipIntro"]}
                />
              </List.Item>
              <p />
              <Modal
                trigger={
                  <Button basic color="blue" size="tiny">
                    Restore defaults
                  </Button>
                }
                size="mini"
                content="Confirm restoration of default settings?"
                actions={[
                  {
                    size: "tiny",
                    key: "cancel-restore-defaults",
                    content: "Cancel",
                  },
                  {
                    size: "tiny",
                    color: "blue",
                    key: "restore-defaults",
                    content: "Restore",
                    onClick: () => {
                      restoreDefaults();
                    },
                  },
                ]}
              />
            </List>
            <p />
          </div>
        ),
      },
    },
  ];

  return <Accordion panels={panels} />;
}
